import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: null,
};

const userProfileInfoSlice = createSlice({
  name: "userProfileInfo",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      const { userInfo } = action.payload;
      state.userInfo = userInfo;
    },
  },
});

export const selectCurrentUserProfileInformation = (state) =>
  state.userProfileInfo.userInfo;

export const { setUserInfo } = userProfileInfoSlice.actions;
export default userProfileInfoSlice.reducer;
